import { requestConstantsMaker } from '../helper';

/**** 20200217 ****/
export const GET_ALL_PAYMENT_METHOD = requestConstantsMaker('GET_ALL_PAYMENT_METHOD');
export const GET_PAYMENT_METHOD = requestConstantsMaker('GET_PAYMENT_METHOD');
export const CREATE_PAYMENT_METHOD = requestConstantsMaker('CREATE_PAYMENT_METHOD');
export const UPDATE_PAYMENT_METHOD = requestConstantsMaker('UPDATE_PAYMENT_METHOD');
export const GET_PAYMENT_METHODS_FOR_SELECTION = requestConstantsMaker('GET_PAYMENT_METHODS_FOR_SELECTION');
/**** 20200217 ****/

export const GET_ALL_PAYMENT_METHOD_BY_SPECIFICATION = requestConstantsMaker('GET_ALL_PAYMENT_METHOD_BY_SPECIFICATION');
export const GET_PAYMENT_METHOD_BY_ID = requestConstantsMaker('GET_PAYMENT_METHOD_BY_ID');
export const POST_CREATE_PAYMENT_METHOD = requestConstantsMaker('POST_CREATE_PAYMENT_METHOD');
export const PUT_UPDATE_PAYMENT_METHOD = requestConstantsMaker('PUT_UPDATE_PAYMENT_METHOD');